package com.eladfinish.bible.contest.screens.names.data

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import com.eladfinish.bible.contest.entities.BaseVerse
import com.eladfinish.bible.contest.gender_men
import com.eladfinish.bible.contest.gender_women
import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.screens.names.ErrorCause
import com.eladfinish.bible.contest.utils.addGershaim
import dev.icerock.moko.resources.StringResource
import io.ktor.http.HttpStatusCode

data class NameReference(
    override val book: String,
    override val chapter: String,
    override val verse: String,
) : BaseVerse {

    val bookAsNumber: Int
        get() = BibleCatalog.books.indexOfFirst { it.hebrew == book }

    override fun toString(): String =
        "$book ${chapter.addGershaim()}, ${verse.addGershaim()}"

}

data class NameItem(
    val name: String,
    val description: String,
    val nameReferenceList: List<NameReference>,
)

data class NamesResult(
    val apiResult: ApiResult<List<NameItem>, Any>,
    val titleSentence: String,
    val linkedRange: TextRange,
    val linkedString: String,
    val link: String,
    val errorCause: ErrorCause = ErrorCause.Http(statusCode = HttpStatusCode.OK),
)

enum class Gender(val directoryName: String, val id: String, val stringResource: StringResource) {
    MALE(directoryName = NamesDatabase.MEN_DIRECTORY, id = "738823670", SharedRes.strings.gender_men),
    FEMALE(directoryName = NamesDatabase.WOMEN_DIRECTORY, id = "1524838414", SharedRes.strings.gender_women);

    companion object {
        fun String.fromString(): Gender = when (this) {
            "אנשים" -> MALE
            "נשים" -> FEMALE
            else -> throw IllegalArgumentException("unknown gender $this")
        }

    }
}
